import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../../../assets/css/products.css";
import { useEffect, useState } from "react";
import api from "../../../shared/utils/request";
import ProductView from "../../shared/productView";
import { Link } from "react-router-dom";

const Products = () => {
  const [productData, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await api.get("customer/get-flash-sale-products");
        setProducts(data?.data);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="product pt-60">
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5
              className="mb-0 wow fadeInLeft"
              style={{ visibility: "visible", animationName: "fadeInLeft" }}
            >
              Flash Sales Today
            </h5>
            <div
              className="flex-align gap-16 wow fadeInRight"
              style={{ visibility: "visible", animationName: "fadeInRight" }}
            >
              <Link
                to="/collections"
                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
              >
                View All Deals
              </Link>
              <div className="flex-align gap-8">
                <button
                  type="button"
                  id="product-one-prev"
                  className="slick-prev flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1 slick-arrow"
                  style={{}}
                >
                  <i className="ph ph-caret-left" />
                </button>
                <button
                  type="button"
                  id="product-one-next"
                  className="slick-next flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1 slick-arrow"
                  style={{}}
                >
                  <i className="ph ph-caret-right" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          slidesPerView={5}
          loop={true}
          navigation={{
            prevEl: "#product-one-prev",
            nextEl: "#product-one-next",
          }}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: { slidesPerView: 2.5 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
            1200: { slidesPerView: 6.5 },
          }}
          className="products-slider"
        >
          {productData?.map((product) => (
            <SwiperSlide key={product.id}>
              <ProductView
                product={{
                  id: product?.id,
                  slug: product?.slug,
                  variant_id: product?.product_variants?.[0]?.id,
                  image: product?.product_variants?.[0]?.product_image,
                  name: product?.product_variants?.[0]?.title,
                  price: product?.product_variants?.[0]?.sale_price,
                  originalPrice: product?.product_variants?.[0]?.price,
                  quantityType: product?.product_variants?.[0]?.quantity,
                  sold: product?.product_variants?.[0]?.stock,
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
export default Products;
